
/* eslint-disable */
export const commentMixin = {
  data() {
    return {
        currentCommentIndex: null,
        toggleCommentChain: false,
        commentChainHtml: "",
        chainExist: true,
    };
  },
 
  methods: {
      /** this function add the last comment in thread onclicking of dot dot icon  */
    createReplyChain(comment, commentIndex) {
      if(commentIndex == this.currentCommentIndex && this.toggleCommentChain){
        this.toggleCommentChain = false;
      }
      else {
        let element = document.getElementById("hidden-comment");
        element.innerHTML = comment.body ? comment.body : "";
        let blockQuote = element.getElementsByTagName("blockquote");
        if (blockQuote.item(0)) {
          this.commentChainHtml = blockQuote.item(0).outerHTML;
          this.toggleCommentChain = true;
          this.currentCommentIndex = commentIndex;
        }
      }
    },

    checkToShowThreadIcon(item, index) {
      let showIcon = false;
      if ((item.comment_type == "reply") && index >= 0) {
        showIcon = true;
        let element = document.getElementById("hidden-comment");
        if (element) {
          element.innerHTML = item.body ? item.body : "";
          let blockQuote = element.getElementsByTagName("blockquote");
          if (!blockQuote.item(0)) {
            showIcon = false;
          }
        }
      }
      return showIcon;
    },
  }
};
